/*****************************************************************************************************************************************************
 * Revision History
 * 2025-01-14 TBH - Set referenceNumber from response.referenceId ("X" + people ID) in bindConfirmationList().
 *****************************************************************************************************************************************************/
export default function olliCartConfirmation() {
    return {
        cartConfirmationDetails: '',
        payments: [],
        terms: [],
        showErrorMesage: "",
        message: "Loading information please wait...",
        showLoader: false,
        total_Amount: 0,
        isSubmitting: false,
        currentFormattedDate: '',
        confirmationMessage: '',
        paymentReceiptNumber: '',
        referenceNumber: '',
        entryDate: '',
        addressDetails: '',
        phoneDetails: '',

        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
               
            );
            return formattedDate;
        },

        bindProfile() {

            this.addressDetails = JSON.parse(sessionStorage.getItem('addressDetails'));
            this.phoneDetails = JSON.parse(sessionStorage.getItem('phoneDetails'));
        },
        bindConfirmationList() {
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/OlliCheckout/olli_confirmation", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {

                    return response.json();
                })
                .then((response) => {
                 
                    this.showLoader = false;

                    if (response != undefined && response.isSuccess) {
                        this.cartConfirmationDetails = response;
                        Array.prototype.push.apply( this.payments, response.payments );

                        if( response.credits != null )
                            this.total_Amount = response.credits.reduce(( sum, item ) => sum += item.amount, 0 );

                        this.referenceNumber = response.referenceId;

                        if( response.payments.length > 0 ) {
                          this.entryDate = new Date( response.payments[ 0 ].entryDate ).toLocaleDateString();
                          this.paymentReceiptNumber = response.payments[ 0 ].receiptNumber;
                          this.confirmationMessage = "Credit Card Sale " + entryDate 
                              + " Card Type " + response.payments[0].cardInfo.split(' ')[0] 
                              + " Entry Method Keyed Card " + response.payments[0].cardInfo.split(' ')[1] 
                              + " Invoice " + this.paymentReceiptNumber 
                              + " Clerk 1 Approved " + response.payments[0].chargeCreditCode 
                              + " Amount USD $" + response.payments[0].amount 
                              + " I Agree to Pay Above Total Amount According to Card Issuer Agreement or Merchant Agreement if Credit Voucher ________________________ Signature: " 
                              + response.payments[0].cardName
                          }
                        setTimeout(function () {
                            fetch("/api/Checkout/clearUserSession", {
                                method: "get",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                }
                            })
                                .then((response) => {
                                    return response.json();
                                })
                                .then((response) => {
                                    if (response != undefined && response.isSuccess) {
                                    } else {

                                    }
                                });
                        }, 1500)


                    } else {
                        this.message = response.messages.length > 0 ? response.messages.join(', ') : response.message;

                    }
                });
        },

        init() {
            this.currentFormattedDate = new Date().toLocaleDateString();
            this.bindProfile();
            this.bindConfirmationList();
        },
    };
}
